module.exports = __webpack_public_path__ + "img/zhaocha_des_1.60a28728.jpg";